import React, { useState } from "react";

import { FlowVersion, FlowVersionFlowChild } from "src/api/flowTypes";
import { SearchBox } from "src/base-components/SearchBox";
import { FlowVersionCard } from "src/SelectFlowPane/FlowVersionCard";
import {
  FlowVersionFilter,
  VersionStatusFilterValue,
} from "src/SelectFlowPane/FlowVersionFilter";
import { getActiveVersions, matchesFilter } from "src/utils/flowVersion";
import { useFuseSearch } from "src/utils/useFuseSearch";

type Props = {
  flowId: string;
  flowVersions: FlowVersionFlowChild[];
  selectedVersionId?: string;
  onSelect: (flowVersion: FlowVersion) => void;
  excludeArchivedVersions: boolean;
};

export const FlowVersionList: React.FC<Props> = ({
  flowVersions,
  flowId,
  onSelect,
  selectedVersionId,
  excludeArchivedVersions,
}) => {
  const [filter, setFilter] = useState<VersionStatusFilterValue>("all");
  const [filterTerm, setFilterTerm] = useState("");
  const versionsToShow = excludeArchivedVersions
    ? getActiveVersions(flowVersions, selectedVersionId)
    : flowVersions;
  const search = useFuseSearch(
    versionsToShow.filter(
      (version) => filter === "all" || matchesFilter(version, filter),
    ),
    { keys: ["name"] },
  );

  return (
    <div className="flex h-full flex-col">
      <div className="flex h-full flex-col gap-y-3">
        <div className="border-gray-100 border-b pb-2">
          <SearchBox placeholder="Search a version" onChange={setFilterTerm} />
        </div>
        <FlowVersionFilter
          value={filter}
          onChange={(value) => setFilter(value)}
        />

        <ul className="decideScrollbar !overflow-y-scroll -mr-4 flex flex-col gap-y-3">
          {search(filterTerm)
            .sort((a, b) => +new Date(b.updated_at) - +new Date(a.updated_at))
            .map((version) => (
              <FlowVersionCard
                key={version.id}
                flowId={flowId}
                selected={version.id === selectedVersionId}
                version={version}
                onClick={() => onSelect(version)}
              />
            ))}
        </ul>
      </div>
    </div>
  );
};
